import type { SVGProps } from 'react';
const SvgQrCode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#qr_code_svg__a)">
      <path d="M3 11h8V3H3v8Zm2-6h4v4H5V5ZM3 21h8v-8H3v8Zm2-6h4v4H5v-4ZM13 3v8h8V3h-8Zm6 6h-4V5h4v4ZM21 19h-2v2h2v-2ZM15 13h-2v2h2v-2ZM17 15h-2v2h2v-2ZM15 17h-2v2h2v-2ZM17 19h-2v2h2v-2ZM19 17h-2v2h2v-2ZM19 13h-2v2h2v-2ZM21 15h-2v2h2v-2Z" />
    </g>
    <defs>
      <clipPath id="qr_code_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQrCode;
